import { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import { User } from 'firebase/auth';

export interface AuthContextType {
  user: User | null;
  userEmail: string | null;
  displayName: string | null;
  profilePictureUrl: string | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  signIn: () => Promise<void>;
  logout: () => Promise<void>;
  checkAppAccess: (appId: string) => Promise<boolean>;
  refreshProfilePicture: () => Promise<void>;
}

export const useAuth = () => useContext(AuthContext);

export default useAuth;
